<p-toast position="top-right"></p-toast>

<!-- ── Lottie Overlay Loader ──────────────────────────────────────────────── -->
<app-loader-overlay [visible]="overlayVisible" [message]="overlayMessage"></app-loader-overlay>

<!-- ── Add Experience Dialog (same fields as Profile → Experience) ─────────── -->
<p-dialog
  [(visible)]="showAddExpDialog"
  [modal]="true"
  [blockScroll]="true"
  [draggable]="false"
  [resizable]="false"
  [header]="editingExpId != null ? 'Edit Work Experience' : 'Add Work Experience'"
  styleClass="ip-confirm-dialog"
  [style]="{ width: '680px', maxWidth: '92vw' }"
  appendTo="body"
>
  @if (newExp) {
    <div class="bi-exp-dialog-grid">
      <div class="bi-cfg-field">
        <label class="bi-cfg-label">Company Name <span class="bi-required">*</span></label>
        <p-select
          [options]="companyOptions"
          [(ngModel)]="newExp.companyName"
          optionLabel="name"
          optionValue="name"
          [filter]="true"
          filterPlaceholder="Search company…"
          placeholder="Select a company"
          class="bi-exp-select w-full"
          appendTo="body"
        >
          <ng-template pTemplate="footer">
            <div class="bi-exp-other-option" (click)="openAddLookupDialog('company')">
              <i class="pi pi-plus"></i> Other (add new)
            </div>
          </ng-template>
        </p-select>
      </div>
      <div class="bi-cfg-field">
        <label class="bi-cfg-label">Job Title / Role <span class="bi-required">*</span></label>
        <p-select
          [options]="jobTitleOptions"
          [(ngModel)]="newExp.role"
          optionLabel="title"
          optionValue="title"
          [filter]="true"
          filterPlaceholder="Search role…"
          placeholder="Select a job title"
          class="bi-exp-select w-full"
          appendTo="body"
        >
          <ng-template pTemplate="footer">
            <div class="bi-exp-other-option" (click)="openAddLookupDialog('role')">
              <i class="pi pi-plus"></i> Other (add new)
            </div>
          </ng-template>
        </p-select>
      </div>
      <div class="bi-cfg-field">
        <label class="bi-cfg-label">Industry</label>
        <p-select
          [options]="industryOptions"
          [(ngModel)]="newExp.industry"
          optionLabel="industryType"
          optionValue="industryType"
          [filter]="true"
          filterPlaceholder="Search industry…"
          placeholder="Select an industry"
          class="bi-exp-select w-full"
          appendTo="body"
        >
          <ng-template pTemplate="footer">
            <div class="bi-exp-other-option" (click)="openAddLookupDialog('industry')">
              <i class="pi pi-plus"></i> Other (add new)
            </div>
          </ng-template>
        </p-select>
      </div>
      <div class="bi-cfg-field">
        <label class="bi-cfg-label">Employment Type</label>
        <p-select
          [options]="employmentTypeOptions"
          [(ngModel)]="newExp.employmentType"
          optionLabel="name"
          optionValue="name"
          [filter]="true"
          filterPlaceholder="Search employment type…"
          placeholder="Select employment type"
          class="bi-exp-select w-full"
          appendTo="body"
        >
          <ng-template pTemplate="footer">
            <div class="bi-exp-other-option" (click)="openAddLookupDialog('employmentType')">
              <i class="pi pi-plus"></i> Other (add new)
            </div>
          </ng-template>
        </p-select>
      </div>
      <div class="bi-cfg-field bi-exp-current-field bi-exp-full-width">
        <label class="bi-exp-checkbox-label bi-exp-checkbox-label--lg">
          <input type="checkbox" [(ngModel)]="newExp.current" />
          <span>I'm currently working here</span>
        </label>
      </div>
      <div class="bi-exp-date-row bi-exp-full-width">
        <div class="bi-cfg-field">
          <label class="bi-cfg-label">Start Month</label>
          <p-select
            [filter]="true"
            filterPlaceholder="Search…"
            appendTo="body"
            class="bi-exp-select w-full"
            [(ngModel)]="newExp.startMonth"
            [options]="expMonths"
            optionLabel="label"
            optionValue="value"
            placeholder="Month"
          ></p-select>
        </div>
        <div class="bi-cfg-field">
          <label class="bi-cfg-label">Start Year <span class="bi-required">*</span></label>
          <p-select
            [filter]="true"
            filterPlaceholder="Search…"
            appendTo="body"
            class="bi-exp-select w-full"
            [(ngModel)]="newExp.startYear"
            [options]="currentYears"
            optionLabel="label"
            optionValue="value"
            placeholder="Year"
          ></p-select>
        </div>
        @if (!newExp.current) {
          <div class="bi-cfg-field">
            <label class="bi-cfg-label">End Month</label>
            <p-select
              [filter]="true"
              filterPlaceholder="Search…"
              appendTo="body"
              class="bi-exp-select w-full"
              [(ngModel)]="newExp.endMonth"
              [options]="expMonths"
              optionLabel="label"
              optionValue="value"
              placeholder="Month"
            ></p-select>
          </div>
        }
        @if (!newExp.current) {
          <div class="bi-cfg-field">
            <label class="bi-cfg-label">End Year</label>
            <p-select
              [filter]="true"
              filterPlaceholder="Search…"
              appendTo="body"
              class="bi-exp-select w-full"
              [(ngModel)]="newExp.endYear"
              [options]="currentYears"
              optionLabel="label"
              optionValue="value"
              placeholder="Year"
            ></p-select>
          </div>
        }
      </div>
      @if (newExpDateError) {
        <div class="bi-exp-dialog-error bi-exp-full-width">
          {{ newExpDateError }}
        </div>
      }
      <div class="bi-cfg-field bi-exp-full-width">
        <label class="bi-cfg-label">Description</label>
        <textarea
          class="bi-exp-input"
          rows="3"
          [(ngModel)]="newExp.description"
          placeholder="Brief description of your role and responsibilities"
        ></textarea>
      </div>
    </div>
  }

  <ng-template pTemplate="footer">
    <button
      class="ip-confirm-btn ip-confirm-btn--cancel"
      (click)="showAddExpDialog = false"
      [disabled]="savingExperience"
    >
      Cancel
    </button>
    <button
      class="ip-confirm-btn ip-confirm-btn--confirm"
      [disabled]="!isNewExpValid || savingExperience"
      (click)="confirmAddExperience()"
    >
      {{ savingExperience ? 'Saving…' : editingExpId != null ? 'Save Changes' : 'Add Experience' }}
    </button>
  </ng-template>
</p-dialog>

<!-- ── Add New <lookup> Dialog (Company / Job Title / Industry / Employment
Type "Other" flow) — asks for the name and saves it to the DB right
away, then selects it in the dropdown it was opened from. ────────────── -->
<p-dialog
  [(visible)]="showAddLookupDialog"
  [modal]="true"
  [blockScroll]="true"
  [draggable]="false"
  [resizable]="false"
  [header]="addLookupTitle"
  styleClass="ip-confirm-dialog"
  [style]="{ width: '420px', maxWidth: '92vw' }"
  appendTo="body"
>
  <div class="bi-cfg-field">
    <label class="bi-cfg-label">Name <span class="bi-required">*</span></label>
    <input
      type="text"
      class="bi-exp-input"
      [(ngModel)]="addLookupValue"
      [placeholder]="addLookupPlaceholder"
      (keydown.enter)="confirmAddLookup()"
    />
  </div>

  <ng-template pTemplate="footer">
    <button
      class="ip-confirm-btn ip-confirm-btn--cancel"
      (click)="showAddLookupDialog = false"
      [disabled]="savingLookup"
    >
      Cancel
    </button>
    <button
      class="ip-confirm-btn ip-confirm-btn--confirm"
      [disabled]="!addLookupValue.trim() || savingLookup"
      (click)="confirmAddLookup()"
    >
      {{ savingLookup ? 'Saving…' : 'Add' }}
    </button>
  </ng-template>
</p-dialog>

<!-- ── Delete Experience Confirmation ───────────────────────────────────────── -->
<p-dialog
  [(visible)]="showDeleteExpConfirm"
  [modal]="true"
  [blockScroll]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="ip-confirm-dialog"
  [style]="{ width: '380px' }"
  appendTo="body"
>
  <ng-template pTemplate="header">
    <div class="ip-confirm-header">
      <div class="ip-confirm-icon" style="background: #fee2e2; color: #b91c1c">
        <i class="pi pi-trash"></i>
      </div>
      <span class="ip-confirm-title">Remove Experience</span>
    </div>
  </ng-template>
  <p class="ip-confirm-body">
    Are you sure you want to remove this work experience entry? This action cannot be undone.
  </p>
  <ng-template pTemplate="footer">
    <div class="ip-confirm-footer">
      <button
        class="ip-confirm-btn ip-confirm-btn--cancel"
        (click)="showDeleteExpConfirm = false; confirmDeleteExpId = null"
      >
        Cancel
      </button>
      <button
        class="ip-confirm-btn ip-confirm-btn--confirm"
        style="background: #ef4444"
        (click)="confirmDeleteExperience()"
      >
        <i class="pi pi-trash"></i> Yes, Remove
      </button>
    </div>
  </ng-template>
</p-dialog>

<div class="bi-page">
  @if (!isInviteFlow) {
    <div class="ip-back-row mb-3">
      <button class="ip-back-btn" routerLink="/app/candidate" aria-label="Back to dashboard">
        <i class="pi pi-arrow-left"></i>
      </button>
      <span class="ip-back-label">Back to Dashboard</span>
    </div>
  }

  @if (isInviteFlow) {
    <div class="bi-invite-header mb-3">
      <img [src]="logoUrl()" alt="Interpanely" class="bi-invite-logo" />
      <button
        type="button"
        class="bi-invite-theme-toggle"
        (click)="toggleDark()"
        aria-label="Toggle light/dark theme"
      >
        <i [class]="darkMode() ? 'pi pi-sun' : 'pi pi-moon'"></i>
      </button>
    </div>
  }

  <ng-template #stepperTpl>
    <div class="bi-stepper">
      <div class="bi-stepper-steps">
        <div
          class="bi-step"
          [class.bi-step--done]="currentStep > 1"
          [class.bi-step--active]="currentStep === 1"
        >
          <div class="bi-step-circle">
            @if (currentStep > 1) {
              <i class="pi pi-check"></i>
            }
            @if (currentStep <= 1) {
              <span>1</span>
            }
          </div>
          <div class="bi-step-text">
            <span class="bi-step-title">Configure Interview</span>
            <span class="bi-step-sub">Department, skills and preferences</span>
          </div>
        </div>

        <div class="bi-step-line" [class.bi-step-line--done]="currentStep > 1"></div>

        <div
          class="bi-step"
          [class.bi-step--done]="currentStep > 2"
          [class.bi-step--active]="currentStep === 2"
        >
          <div class="bi-step-circle">
            @if (currentStep > 2) {
              <i class="pi pi-check"></i>
            }
            @if (currentStep <= 2) {
              <span>2</span>
            }
          </div>
          <div class="bi-step-text">
            <span class="bi-step-title">Choose Slot</span>
            <span class="bi-step-sub">Pick date and time</span>
          </div>
        </div>

        <div class="bi-step-line" [class.bi-step-line--done]="currentStep > 2"></div>

        <div class="bi-step" [class.bi-step--active]="currentStep === 3">
          <div class="bi-step-circle">
            <span>3</span>
          </div>
          <div class="bi-step-text">
            <span class="bi-step-title">{{ isInviteFlow ? 'Confirm' : 'Payment' }}</span>
            <span class="bi-step-sub">Complete your booking</span>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- ══════════════════════════════════════════════════════════════════════
    STEP 1 — Configure Interview
    ═══════════════════════════════════════════════════════════════════════ -->
  @if (currentStep === 1) {
    <div class="bi-card">
      <div class="bi-card-stepper-wrap">
        <ng-container [ngTemplateOutlet]="stepperTpl"></ng-container>
      </div>
      <div class="bi-title-block">
        <h2 class="bi-title font-bold">Configure Your Interview</h2>
        <p class="bi-subtitle">
          Tell us what you want to be interviewed on, and we'll match you with the right expert.
        </p>
      </div>
      <!-- Skeleton loader — shown while loadStep1Config()/loadBookingContext()'s
        request for Department/Primary Skill/Focus Skills/Experience is in
        flight, so the step doesn't flash empty fields first. -->
      @if (step1Loading) {
        <div class="bi-cfg-layout">
          <div class="bi-cfg-card">
            <p-skeleton height="1.1rem" width="9rem" styleClass="mb-4"></p-skeleton>
            <div class="bi-cfg-field-row">
              <div class="bi-cfg-field bi-cfg-field-half">
                <p-skeleton height="0.85rem" width="6rem" styleClass="mb-2"></p-skeleton>
                <p-skeleton height="2.9rem" borderRadius="10px"></p-skeleton>
              </div>
              <div class="bi-cfg-field bi-cfg-field-half">
                <p-skeleton height="0.85rem" width="6rem" styleClass="mb-2"></p-skeleton>
                <p-skeleton height="2.9rem" borderRadius="10px"></p-skeleton>
              </div>
            </div>
            <div class="bi-cfg-field" style="margin-top: 1.25rem">
              <p-skeleton height="0.85rem" width="10rem" styleClass="mb-2"></p-skeleton>
              <div class="bi-cfg-chip-field">
                @for (_ of [1, 2, 3]; track _) {
                  <p-skeleton height="1.6rem" width="5rem" borderRadius="999px"></p-skeleton>
                }
              </div>
            </div>
            <div class="bi-cfg-field" style="margin-top: 1.25rem">
              <p-skeleton height="0.85rem" width="8rem" styleClass="mb-2"></p-skeleton>
              @for (_ of [1, 2]; track _) {
                <div class="bi-exp-row" style="margin-top: 0.5rem">
                  <div class="bi-exp-row-main">
                    <p-skeleton width="34px" height="34px" borderRadius="9px"></p-skeleton>
                    <div class="bi-exp-row-body" style="gap: 0.35rem">
                      <p-skeleton height="0.85rem" width="10rem"></p-skeleton>
                      <p-skeleton height="0.75rem" width="7rem"></p-skeleton>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
          <div class="bi-summary-card">
            <p-skeleton height="1.1rem" width="8rem" styleClass="mb-4"></p-skeleton>
            @for (_ of [1, 2, 3, 4]; track _) {
              <div class="bi-summary-row">
                <p-skeleton width="2.4rem" height="2.4rem" borderRadius="10px"></p-skeleton>
                <div style="flex: 1">
                  <p-skeleton height="0.8rem" width="5rem" styleClass="mb-2"></p-skeleton>
                  <p-skeleton height="0.9rem" width="8rem"></p-skeleton>
                </div>
              </div>
            }
          </div>
        </div>
      }
      @if (!step1Loading) {
        <div class="bi-cfg-layout">
          <!-- ── Left: Interview Details form ── -->
          <div class="bi-cfg-card">
            <h3 class="bi-cfg-card-title">Interview Details</h3>
            <!-- Profile incomplete guard — a candidate needs at least one saved
              Primary Skill before they can book; adding one only happens on
              the Profile page now. Department can still be filled in below. -->
            @if (noPrimarySkill && !isInviteFlow) {
              <div class="bi-profile-warn">
                <i class="pi pi-exclamation-triangle"></i>
                <span class="bi-profile-warn-text">
                  You need to add a <strong>Primary Skill</strong> in your profile before you can
                  book an interview.
                  <a class="bi-profile-warn-link" routerLink="/app/candidate/profile"
                    >Go to Profile</a
                  >
                </span>
              </div>
            }
            <!-- Department + Primary Skill — editable for a retail candidate
              (synced with the Profile page). For an invite-flow (corporate)
              candidate these are pre-filled with what the corporate user
              already fixed at invite time and disabled -- same fields, same
              layout, just not editable (there's also no JWT in this flow to
              save an edit through anyway). -->
            <div class="bi-cfg-field-row">
              <div class="bi-cfg-field bi-cfg-field-half">
                <label class="bi-cfg-label">
                  Department <span class="bi-required">*</span>
                  @if (savingDepartment) {
                    <i class="pi pi-spin pi-spinner bi-cfg-info-icon"></i>
                  }
                </label>
                <p-select
                  [options]="departmentOptions"
                  [(ngModel)]="selectedDepartmentOption"
                  optionLabel="departmentName"
                  dataKey="id"
                  [filter]="!isInviteFlow"
                  filterPlaceholder="Search department…"
                  placeholder="Select department"
                  [disabled]="savingDepartment || isInviteFlow"
                  (onFocus)="ensureDepartmentsLoaded()"
                  (onChange)="onDepartmentOptionChange()"
                  styleClass="bi-cfg-p-select w-full"
                  appendTo="body"
                >
                  @if (!isInviteFlow) {
                    <ng-template pTemplate="footer">
                      <div class="bi-exp-other-option" (click)="openAddLookupDialog('department')">
                        <i class="pi pi-plus"></i> Other (add new)
                      </div>
                    </ng-template>
                  }
                </p-select>
              </div>
              <!-- Primary Skill — a picker over the candidate's own saved primary
                skills for this specific booking, not an editor of them. -->
              <div class="bi-cfg-field bi-cfg-field-half">
                <label class="bi-cfg-label">
                  Primary Skill <span class="bi-required">*</span>
                </label>
                <p-select
                  [options]="myPrimarySkills"
                  [(ngModel)]="selectedPrimarySkillForBooking"
                  optionLabel="primarySkillName"
                  dataKey="primarySkillId"
                  placeholder="Select primary skill"
                  [disabled]="noPrimarySkill || isInviteFlow"
                  (onChange)="onPrimarySkillForBookingChange()"
                  styleClass="bi-cfg-p-select w-full"
                  appendTo="body"
                >
                  @if (!isInviteFlow) {
                    <ng-template pTemplate="footer">
                      <div class="bi-exp-other-option" (click)="openAddLookupDialog('skill')">
                        <i class="pi pi-plus"></i> Other (add new)
                      </div>
                    </ng-template>
                  }
                </p-select>
              </div>
            </div>
            <!-- Focus Skills -- same chip UI for both flows; for invite flow the
              chips are the corporate-fixed skills with no remove icon, and the
              "Add skills…" control is disabled. -->
            <div class="bi-cfg-field">
              <label class="bi-cfg-label">
                Focus Skills (Optional)
                <i
                  class="pi pi-info-circle bi-cfg-info-icon"
                  pTooltip="Skills the interviewer should emphasise"
                ></i>
                @if (!isInviteFlow) {
                  <span class="bi-cfg-cap">You can select up to {{ MAX_FOCUS_SKILLS }} skills</span>
                }
              </label>
              @if (noPrimarySkill && !isInviteFlow) {
                <div class="bi-no-slots">
                  <i class="pi pi-exclamation-circle"></i>
                  <span>Select a Primary Skill above to pick focus skills for this interview.</span>
                </div>
              }
              <!-- Invite flow with no fixed skills -- an empty chip box with no
                add control looked broken, so show the same empty-state
                pattern as Work Experience below instead. -->
              @if (isInviteFlow && !selectedSkills.length) {
                <div class="bi-no-slots">
                  <i class="pi pi-exclamation-circle"></i>
                  <span>No focus skills specified.</span>
                </div>
              }
              @if ((!noPrimarySkill && !isInviteFlow) || (isInviteFlow && selectedSkills.length)) {
                <div class="bi-cfg-chip-field">
                  @for (s of selectedSkills; track s) {
                    <span class="bi-cfg-chip">
                      {{ s.skill }}
                      @if (!isInviteFlow) {
                        <i class="pi pi-times" (click)="removeFocusSkill(s)"></i>
                      }
                    </span>
                  }
                  @if (!isInviteFlow) {
                    <p-multiselect
                      [filter]="true"
                      filterPlaceholder="Add skills…"
                      class="bi-cfg-chip-input"
                      [(ngModel)]="selectedSkills"
                      (onChange)="onFocusSkillsChange()"
                      (onFocus)="ensureChildSkillsLoaded()"
                      [options]="childSkills"
                      optionLabel="skill"
                      [selectionLimit]="MAX_FOCUS_SKILLS"
                      [showToggleAll]="false"
                      placeholder="Add skills…"
                      [maxSelectedLabels]="0"
                      selectedItemsLabel="Add skills…"
                    >
                      <ng-template pTemplate="footer">
                        <div class="bi-exp-other-option" (click)="openAddLookupDialog('skill')">
                          <i class="pi pi-plus"></i> Other (add new)
                        </div>
                      </ng-template>
                    </p-multiselect>
                  }
                </div>
              }
            </div>
            <!-- Experience — only shown in the left card for non-invite flow.
              In invite flow, experience is shown in the right summary card instead. -->
            @if (!isInviteFlow) {
              <div class="bi-cfg-field">
                <div class="bi-exp-header-row">
                  <div class="bi-exp-header-text">
                    <label class="bi-cfg-label">Work Experience</label>
                    <span class="bi-cfg-hint"
                      >Helps match you with an interviewer at your level. Saved to your
                      profile.</span
                    >
                  </div>
                  @if (!isInviteFlow) {
                    <button
                      type="button"
                      class="bi-exp-add-btn"
                      (click)="openAddExperienceDialog()"
                    >
                      <i class="pi pi-plus"></i> Add Experience
                    </button>
                  }
                </div>
                @if (experiences.length) {
                  <div class="bi-exp-list">
                    @for (exp of experiences; track exp) {
                      <div class="bi-exp-row">
                        <div class="bi-exp-row-main">
                          <div class="bi-exp-row-icon"><i class="pi pi-briefcase"></i></div>
                          <div class="bi-exp-row-body">
                            <span class="bi-exp-row-title"
                              >{{ exp.role }} · {{ exp.companyName }}</span
                            >
                            <span class="bi-exp-row-sub">{{ expDurationLabel(exp) }}</span>
                          </div>
                        </div>
                        <div class="bi-exp-row-actions">
                          @if (exp.current) {
                            <span class="bi-exp-row-badge">Current</span>
                          }
                          @if (!isInviteFlow) {
                            <button
                              type="button"
                              class="bi-exp-row-edit"
                              (click)="openEditExperienceDialog(exp)"
                              pTooltip="Edit"
                              tooltipPosition="top"
                            >
                              <i class="pi pi-pencil"></i>
                            </button>
                            <button
                              type="button"
                              class="bi-exp-row-delete"
                              (click)="requestDeleteExperience(exp.id)"
                              pTooltip="Remove"
                              tooltipPosition="top"
                            >
                              <i class="pi pi-trash"></i>
                            </button>
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
                @if (!experiences.length) {
                  <div class="bi-no-slots" style="margin-top: 0.85rem">
                    <i class="pi pi-briefcase"></i>
                    <span>No work experience added yet.</span>
                  </div>
                }
              </div>
            }
          </div>
          <!-- ── Right: Your Interview summary ── -->
          <div class="bi-summary-card">
            <div class="bi-summary-header">
              <div>
                <h3 class="bi-summary-title">Your Selection</h3>
                <p class="bi-summary-sub">Review your configuration</p>
              </div>
            </div>
            <div class="bi-summary-row">
              <div class="bi-summary-icon"><i class="pi pi-desktop"></i></div>
              <div>
                <span class="bi-summary-label">Department</span>
                <span class="bi-summary-value">{{ candidateDepartment || 'Not set' }}</span>
              </div>
            </div>
            @if (!isInviteFlow) {
              <div class="bi-summary-row">
                <div class="bi-summary-icon"><i class="pi pi-code"></i></div>
                <div>
                  <span class="bi-summary-label">Primary Skill</span>
                  <span class="bi-summary-value">{{
                    noPrimarySkill ? 'Not set' : primarySkillName
                  }}</span>
                </div>
              </div>
            }
            <!-- Job Title was already entered by the corporate user at invite
                time (BookingContextResponse.jobTitle) -- shown here instead
                of the retail-only Primary Skill row, which doesn't apply to
                an invited candidate at all. -->
            @if (isInviteFlow) {
              <div class="bi-summary-row">
                <div class="bi-summary-icon"><i class="pi pi-code"></i></div>
                <div>
                  <span class="bi-summary-label">Job Title</span>
                  <span class="bi-summary-value">{{ bookingContext?.jobTitle || 'Not set' }}</span>
                </div>
              </div>
            }
            <!-- Primary Skill / Skill were attached to the candidate's profile
                by the corporate user when they were invited (see
                InviteUserService.inviteCandidate()) -- fixed, read-only here,
                same as Department/Job Title above. -->
            @if (isInviteFlow) {
              <div class="bi-summary-row">
                <div class="bi-summary-icon"><i class="pi pi-star"></i></div>
                <div>
                  <span class="bi-summary-label">Primary Skill</span>
                  <span class="bi-summary-value">{{
                    bookingContext?.primarySkillName || 'Not set'
                  }}</span>
                </div>
              </div>
            }
            @if (isInviteFlow) {
              <div class="bi-summary-row">
                <div class="bi-summary-icon"><i class="pi pi-server"></i></div>
                <div>
                  <span class="bi-summary-label">Skill</span>
                  <span class="bi-summary-value">{{ inviteFocusSkillsSummary || 'Not set' }}</span>
                </div>
              </div>
            }
            @if (isInviteFlow) {
              <div class="bi-summary-row">
                <div class="bi-summary-icon"><i class="pi pi-briefcase"></i></div>
                <div>
                  <span class="bi-summary-label">Experience</span>
                  <span class="bi-summary-value">{{
                    bookingContext?.experience
                      ? bookingContext!.experience +
                        ' yr' +
                        (bookingContext!.experience === '1' ? '' : 's')
                      : 'None added yet'
                  }}</span>
                </div>
              </div>
            }
            @if (!isInviteFlow) {
              <div class="bi-summary-row">
                <div class="bi-summary-icon"><i class="pi pi-server"></i></div>
                <div>
                  <span class="bi-summary-label">Focus Skills</span>
                  <span class="bi-summary-value">{{
                    selectedSkills.length ? focusSummary : 'None selected yet'
                  }}</span>
                </div>
              </div>
            }
            @if (!isInviteFlow) {
              <div class="bi-summary-row">
                <div class="bi-summary-icon"><i class="pi pi-briefcase"></i></div>
                <div>
                  <span class="bi-summary-label">Experience</span>
                  <span class="bi-summary-value">{{ totalExperienceLabel }}</span>
                </div>
              </div>
            }
          </div>
        </div>
      }
      <!-- Footer -->
      <div class="bi-cfg-footer">
        <div class="bi-footer-summary">
          <span class="bi-footer-summary-date">Step 1 · Configure Interview</span>
          @if (candidateDepartment) {
            <span class="bi-footer-summary-time">
              {{ candidateDepartment }}
              @if (!noPrimarySkill) {
                <span> · {{ primarySkillName }}</span>
              }
            </span>
          }
        </div>
        <div class="bi-footer-actions">
          <button class="bi-btn-secondary" routerLink="/app/candidate">
            <i class="pi pi-arrow-left"></i> Back
          </button>
          <button
            class="bi-btn-primary"
            [class.bi-btn-primary--disabled]="!canContinueFromStep1"
            [disabled]="!canContinueFromStep1"
            (click)="continueToStep2()"
          >
            Continue to Choose Slot <i class="pi pi-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>
  }

  <!-- ══════════════════════════════════════════════════════════════════════
    STEP 2 — Choose Slot
    ═══════════════════════════════════════════════════════════════════════ -->
  @if (currentStep === 2) {
    <div class="bi-card">
      <div class="bi-card-stepper-wrap">
        <ng-container [ngTemplateOutlet]="stepperTpl"></ng-container>
      </div>
      <div class="bi-inner">
        <!-- Shared Choose Slot UI (calendar + slot grid + tier panel), also
          used by request-reschedule -- see choose-slot.component.ts. It
          owns month/year navigation and the day grid itself now
          ([(currentMonth)]/[(currentYear)] two-way bound below); it
          still owns no HTTP calls or slot state of its own -- all of
          that (departments/skills/pricing/credits/payment here, the
          locked panel level over there) stays in each parent. -->
        <!-- Corporate-invited candidates (isInviteFlow) have no tier to pick
          or price to see -- the level is fixed corporate-side, so
          showTierPanel/showTierInfoCard are off and a slot commits
          immediately via selectInviteSlot(), same as
          RequestScheduleComponent's locked-level flow. -->
        <app-choose-slot
          [months]="months"
          [(currentMonth)]="currentMonth"
          [(currentYear)]="currentYear"
          [selectedDate]="selectedDate"
          [availableDates]="availableDates"
          [loadingDates]="loadingDates"
          [tierInfo]="TIER_INFO"
          [priceForLevel]="priceForLevel"
          [showTierInfoCard]="!isInviteFlow"
          [showTierPanel]="!isInviteFlow"
          [slots]="availableSlots"
          [loadingSlots]="loadingSlots"
          [selectedSlotTime]="selectedSlotTime"
          [expandedSlotTime]="expandedSlotTime"
          [selectedPanelLevel]="selectedPanelLevel"
          [allPanelLevels]="ALL_PANEL_LEVELS"
          [suggestedDates]="suggestedDates"
          [loadingSuggestions]="loadingSuggestions"
          (monthChange)="loadAvailableDates()"
          (clearDateClick)="clearDate()"
          (dateSelect)="selectDate($event)"
          (slotClick)="isInviteFlow ? selectInviteSlot($event) : toggleSlotExpand($event)"
          (tierSelect)="chooseTierForSlot($event.slot, $event.level)"
          (suggestedDateSelect)="pickSuggestedDate($event)"
          (requestLinkClick)="showRequestPopup = true"
        ></app-choose-slot>
      </div>
      <!-- Footer -->
      <div class="bi-cfg-footer">
        <!-- Always rendered (even with no content) so it keeps occupying a
          flex slot -- otherwise, clearing the date removes this whole
          block and the lone .bi-footer-actions child left over shifts to
          the start instead of staying pinned to the right. -->
        <div class="bi-footer-summary">
          @if (selectedDate) {
            <span class="bi-footer-summary-date"
              >{{ months[currentMonth] }} {{ selectedDate }}, {{ currentYear }} ·
              {{ footerHintText }}</span
            >
          }
          @if (selectedDate && footerSelectedTimeLabel) {
            <span class="bi-footer-summary-time">{{ footerSelectedTimeLabel }} selected</span>
          }
        </div>
        <div class="bi-footer-actions">
          <button class="bi-btn-secondary" (click)="backToStep1()">
            <i class="pi pi-arrow-left"></i> Back
          </button>
          <button
            class="bi-btn-primary"
            [class.bi-btn-primary--disabled]="!isScheduleValid"
            [disabled]="!isScheduleValid"
            (click)="scheduleInterview()"
          >
            {{ isInviteFlow ? 'Continue to Confirm' : 'Continue to Payment' }}
            <i class="pi pi-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>
  }

  <!-- ══════════════════════════════════════════════════════════════════════
        STEP 3 — Payment
        ═══════════════════════════════════════════════════════════════════════ -->
  @if (currentStep === 3) {
    <div class="bi-card">
      <div class="bi-card-stepper-wrap">
        <ng-container [ngTemplateOutlet]="stepperTpl"></ng-container>
      </div>
      <div class="bi-title-block">
        <h2 class="bi-title font-bold">Complete Your Booking</h2>
        <p class="bi-subtitle">Review your interview details and confirm your booking.</p>
      </div>
      <!-- Skeleton loader — shown while loadRealInterviewPrice() (kicked off
            right when Step 3 is entered) is fetching the real charge amount,
            so Order Summary/Total don't flash a possibly-stale fallback price
            before the real one settles. -->
      @if (step3Loading) {
        <div class="bi-payment-layout">
          <div class="bi-cfg-card">
            <p-skeleton height="1.1rem" width="9rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton height="0.85rem" width="16rem" styleClass="mb-4"></p-skeleton>
            <div class="bi-confirm-details flex flex-column" style="gap: 0.75rem">
              <p-skeleton height="1rem" width="14rem"></p-skeleton>
              <p-skeleton height="1rem" width="12rem"></p-skeleton>
              <p-skeleton height="1rem" width="10rem"></p-skeleton>
              <p-skeleton height="1rem" width="11rem"></p-skeleton>
            </div>
            <p-skeleton height="4.5rem" borderRadius="10px" styleClass="mt-4"></p-skeleton>
          </div>
          <div class="bi-summary-card">
            <p-skeleton height="1.1rem" width="6rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton height="0.85rem" width="14rem" styleClass="mb-4"></p-skeleton>
            <p-skeleton height="2.5rem" width="8rem"></p-skeleton>
          </div>
        </div>
      }
      @if (!step3Loading) {
        <div class="bi-payment-layout" [class.bi-payment-layout--single]="isInviteFlow">
          <div class="bi-cfg-card">
            <h3 class="bi-cfg-card-title">Order Summary</h3>
            <p class="bi-cfg-card-sub">You are about to schedule the following interview.</p>
            <div class="bi-confirm-details flex flex-column">
              <div class="bi-confirm-row bi-confirm-row--split flex align-items-center">
                <span class="bi-confirm-row-item">
                  <i class="pi pi-calendar"></i>
                  <span
                    ><strong>Date:</strong> {{ months[currentMonth] }} {{ selectedDate }},
                    {{ currentYear }}
                  </span>
                </span>
                @if (selectedSlot) {
                  <span class="bi-confirm-row-item">
                    <i class="pi pi-clock"></i>
                    <span><strong>Time:</strong> {{ slotStartTime(selectedSlot.slot) }}</span>
                  </span>
                }
              </div>
              @if (!isInviteFlow) {
                <div class="bi-confirm-row flex align-items-center">
                  <i class="pi pi-code"></i>
                  <span
                    ><strong>Primary Skill:</strong>
                    {{ noPrimarySkill ? 'Not set' : primarySkillName }}</span
                  >
                </div>
              }
              <div class="bi-confirm-row flex align-items-center">
                <i class="pi pi-tag"></i>
                <span><strong>Focus:</strong> {{ focusSummary }}</span>
              </div>
              @if (!isInviteFlow) {
                <div class="bi-confirm-row flex align-items-center">
                  <i class="pi pi-star"></i>
                  <span><strong>Panel Level:</strong> {{ selectedPanelLevel }}</span>
                </div>
              }
            </div>
            @if (!isInviteFlow) {
              <div class="bi-coupon-box">
                <label class="bi-coupon-label">Have a coupon?</label>
                <div class="bi-coupon-row">
                  <input
                    type="text"
                    class="bi-coupon-input"
                    placeholder="Enter coupon code"
                    [(ngModel)]="couponCodeInput"
                    [disabled]="!!appliedCoupon || applyingCoupon"
                    (keyup.enter)="applyCoupon()"
                  />
                  @if (!appliedCoupon) {
                    <button
                      type="button"
                      class="bi-coupon-btn"
                      [disabled]="!couponCodeInput || applyingCoupon"
                      (click)="applyCoupon()"
                    >
                      {{ applyingCoupon ? 'Checking…' : 'Apply' }}
                    </button>
                  }
                  @if (appliedCoupon) {
                    <button
                      type="button"
                      class="bi-coupon-btn bi-coupon-btn--remove"
                      (click)="removeCoupon()"
                    >
                      Remove
                    </button>
                  }
                </div>
                @if (appliedCoupon || couponError) {
                  <div
                    class="bi-coupon-msg"
                    [class.bi-coupon-msg--success]="appliedCoupon"
                    [class.bi-coupon-msg--error]="couponError"
                  >
                    <i
                      class="pi"
                      [ngClass]="appliedCoupon ? 'pi-check-circle' : 'pi-times-circle'"
                    ></i>
                    {{
                      appliedCoupon
                        ? appliedCoupon.couponCode +
                          ' applied — ₹' +
                          (appliedCoupon.discountAmount | number: '1.0-0') +
                          ' off'
                        : couponError
                    }}
                  </div>
                }
              </div>
            }
          </div>
          @if (!isInviteFlow) {
            <div class="bi-summary-card">
              <div class="bi-summary-header">
                <div>
                  <h3 class="bi-summary-title">Payment Summary</h3>
                  <p class="bi-summary-sub">Amount to be charged for this interview</p>
                </div>
              </div>
              <!-- Itemised bill, same shape as a checkout bill summary: a line
                        per charge/discount, then a divider, then the bold total. -->
              <div class="bi-bill">
                <div class="bi-bill-row">
                  <span class="bi-bill-row-label">Interview Fee</span>
                  <span class="bi-bill-row-value"
                    >₹{{
                      realInterviewPrice ?? priceForLevel(selectedPanelLevel) | number: '1.0-0'
                    }}</span
                  >
                </div>
                @if (appliedCoupon) {
                  <div class="bi-bill-row">
                    <span class="bi-bill-row-label">Coupon ({{ appliedCoupon.couponCode }})</span>
                    <span class="bi-bill-row-value bi-bill-row-value--discount"
                      >-₹{{ appliedCoupon.discountAmount | number: '1.0-0' }}</span
                    >
                  </div>
                }
                <!-- Interpanely Coins — same gold coin treatment as the Coins
                              page, as a bill row here rather than a boxed panel, so it
                              reads as one more line feeding into the total below. -->
                @if (!isInviteFlow) {
                  <div class="bi-bill-row bi-bill-row--coins">
                    <span class="bi-bill-row-label bi-coin-row-label">
                      <svg
                        class="bi-coin-icon"
                        width="18"
                        height="18"
                        viewBox="0 0 32 32"
                        aria-hidden="true"
                      >
                        <defs>
                          <linearGradient id="biCoinFace" x1="0" y1="0" x2="1" y2="1">
                            <stop offset="0" stop-color="#ffe259" />
                            <stop offset="1" stop-color="#f5a623" />
                          </linearGradient>
                          <linearGradient id="biCoinRim" x1="0" y1="1" x2="1" y2="0">
                            <stop offset="0" stop-color="#b8760a" />
                            <stop offset="1" stop-color="#ffd54f" />
                          </linearGradient>
                        </defs>
                        <circle cx="16" cy="16" r="15" fill="url(#biCoinRim)" />
                        <circle cx="16" cy="16" r="12" fill="url(#biCoinFace)" />
                        <circle
                          cx="16"
                          cy="16"
                          r="12"
                          fill="none"
                          stroke="#c98a12"
                          stroke-width="0.8"
                          stroke-dasharray="1.6 1.6"
                        />
                        <text
                          x="16"
                          y="21"
                          text-anchor="middle"
                          font-size="14"
                          font-weight="800"
                          font-family="Plus Jakarta Sans, sans-serif"
                          fill="#8a5a00"
                        >
                          ₹
                        </text>
                      </svg>
                      Interpanely Coins
                    </span>
                    <span class="bi-bill-row-value">
                      @if (!loadingCoins) {
                        {{ totalCoins ?? 0 | number }} coins
                      } @else {
                        <p-skeleton height="0.9rem" width="4rem"></p-skeleton>
                      }
                    </span>
                  </div>
                }
                @if (!isInviteFlow) {
                  <div class="bi-bill-subrow">
                    <span class="bi-coin-box-note"
                      >Minimum {{ MIN_REDEEM_COINS | number }} coins can be redeemed.</span
                    >
                    <label
                      class="bi-coin-toggle"
                      [class.bi-coin-toggle--disabled]="!canRedeemCoins"
                    >
                      <p-checkbox
                        [binary]="true"
                        [ngModel]="redeemCoins"
                        [disabled]="!canRedeemCoins"
                        (onChange)="toggleRedeemCoins()"
                        styleClass="bi-coin-checkbox"
                      ></p-checkbox>
                      <span>Redeem</span>
                    </label>
                  </div>
                }
                @if (!isInviteFlow && redeemCoins && coinDiscount) {
                  <div class="bi-bill-row">
                    <span class="bi-bill-row-label"
                      >Coins Redeemed{{
                        coinsToRedeem ? ' (' + (coinsToRedeem | number) + ' coins)' : ''
                      }}</span
                    >
                    <span class="bi-bill-row-value bi-bill-row-value--discount"
                      >-₹{{ coinDiscount | number: '1.0-0' }}</span
                    >
                  </div>
                }
                <div class="bi-bill-divider"></div>
                <div class="bi-bill-total-row">
                  <span class="bi-bill-total-label">Total Amount</span>
                  <span class="bi-bill-total-value">₹{{ totalPayable | number: '1.0-0' }}</span>
                </div>
              </div>
            </div>
          }
        </div>
      }
      <!-- Footer -->
      <div class="bi-cfg-footer">
        <div class="bi-footer-summary">
          <span class="bi-footer-summary-date">{{
            isInviteFlow ? 'Step 3 · Confirm' : 'Step 3 · Payment'
          }}</span>
          @if (selectedSlot) {
            <span class="bi-footer-summary-time">
              {{ months[currentMonth] }} {{ selectedDate }}, {{ currentYear }} ·
              {{ slotStartTime(selectedSlot.slot) }}
            </span>
          }
        </div>
        <div class="bi-footer-actions">
          <button
            class="bi-btn-secondary"
            (click)="backToStep2()"
            [disabled]="scheduling || payingForInterview || booked || paymentCompleted"
          >
            <i class="pi pi-arrow-left"></i> Back
          </button>
          <button
            class="bi-btn-primary"
            [disabled]="scheduling || payingForInterview || booked || paymentCompleted"
            (click)="confirmSchedule()"
          >
            <i class="pi pi-check"></i>
            {{
              booked
                ? 'Booked'
                : scheduling
                  ? 'Booking…'
                  : payingForInterview
                    ? 'Processing…'
                    : paymentCompleted
                      ? 'Payment Received'
                      : isInviteFlow
                        ? 'Confirm & Book'
                        : 'Pay & Book'
            }}
          </button>
        </div>
      </div>
    </div>
  }
</div>

<!-- ── Request Time-Slot popup (bottom-left) ────────────────────────────── -->
@if (showRequestPopup) {
  <div class="bi-popup" [@popupAnim]>
    <div class="bi-popup__header">
      <span class="bi-popup__title">Add Time-Slot</span>
      <button class="bi-popup__close" (click)="showRequestPopup = false">
        <i class="pi pi-times"></i>
      </button>
    </div>
    <div class="bi-popup__body">
      <label class="bi-popup__label">Date <span class="bi-required">*</span></label>
      <div class="bi-popup__input-wrap">
        <input type="date" class="bi-popup__input" [(ngModel)]="requestDate" />
        <i class="pi pi-calendar bi-popup__input-icon"></i>
      </div>
      <label class="bi-popup__label">Time <span class="bi-required">*</span></label>
      <div class="bi-popup__input-wrap">
        <input type="time" class="bi-popup__input" [(ngModel)]="requestTime" />
        <i class="pi pi-clock bi-popup__input-icon"></i>
      </div>
    </div>
    <button class="bi-popup__submit" [disabled]="!isRequestValid" (click)="submitTimeSlotRequest()">
      Request Time-Slot
    </button>
  </div>
}
